// parse "resource:action" -> { resource: [action] }
export function parsePermissionString(perm: string) {
    const [resource, actionsRaw] = perm.split(":");
    if (!resource || !actionsRaw) throw new Error("Invalid permission string: " + perm);
    const actions = actionsRaw.split(",").map(a => a.trim()).filter(Boolean);
    return { [resource]: actions };
}

// small helpers
export function isManagementPermission(permission: string) {
    return permission.includes("_management:") || permission.endsWith(":all");
}
export function isReadPermission(permission: string) {
    return permission.includes("_read:");
}

export type PermObject = Record<string, string[]>;
